import React from 'react';

const DEFAULT_SIZE = 24;

export interface DroneIconProps extends React.SVGAttributes<SVGSVGElement> {
  size?: number;
  className?: string;
}

/**
 * أيقونة درون مخصصة — Line/outline فقط، بنفس أسلوب Lucide.
 * جسم دائري في المنتصف، أربع مراوح دائرية في الزوايا، أذرع رفيعة تربطها.
 */
const DroneIcon = React.forwardRef<SVGSVGElement, DroneIconProps>(
  ({ size = DEFAULT_SIZE, className = '', ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* مركز — جسم دائري */}
      <circle cx="12" cy="12" r="2.5" />
      {/* مروحة أعلى يسار */}
      <circle cx="7" cy="7" r="1.5" />
      {/* مروحة أعلى يمين */}
      <circle cx="17" cy="7" r="1.5" />
      {/* مروحة أسفل يسار */}
      <circle cx="7" cy="17" r="1.5" />
      {/* مروحة أسفل يمين */}
      <circle cx="17" cy="17" r="1.5" />
      {/* أذرع من المركز إلى المراوح */}
      <line x1="12" y1="12" x2="7" y2="7" />
      <line x1="12" y1="12" x2="17" y2="7" />
      <line x1="12" y1="12" x2="7" y2="17" />
      <line x1="12" y1="12" x2="17" y2="17" />
    </svg>
  )
);

DroneIcon.displayName = 'DroneIcon';

export default DroneIcon;
